export class Rules {
	constructor() {

	}

	static getOpcionesNormales( questions ) {
		const filtered = questions.filter( o => {
			return o.CABOPTPignon === false &&
			o.CABOPTLateral === false &&
			o.CABOPTCAPILLA === false &&
			o.CABOPTTransvers === false &&
			o.CABOPTZona === false &&
			o.CABOPTPuntofijo === false; 
		} );

		return filtered;
	}

	static getOpcionesCapilla( questions ) {
		const filtered = questions.filter( o => o.CABOPTCAPILLA === true );

		return filtered;
	}

	static getOpcionesTransversales( questions ) {
		const filtered = questions.filter( o => o.CABOPTTransvers === true );

		return filtered;
	}

	static getOpcionesPuntoFijo( questions ) {
		const filtered = questions.filter( o => o.CABOPTPuntofijo === true );

		return filtered;
	}

	static getOpcionesLateral( questions ) {
		const filtered = questions.filter( o => o.CABOPTLateral === true );

		return filtered;
	}

	static getOpcionesZona( questions ) {
		const filtered = questions.filter( o => o.CABOPTZona === true );

		return filtered;
	}

	static getOpcionesFrontalNorte( questions ) {
		
		const filtered = questions.filter( o => o.CABOPTPignon === true );

		return filtered;
	}
}